import { render } from "./StockSearch.vue?vue&type=template&id=56fe0710&scoped=true"
import script from "./StockSearch.vue?vue&type=script&lang=js"
export * from "./StockSearch.vue?vue&type=script&lang=js"

import "./StockSearch.vue?vue&type=style&index=0&id=56fe0710&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fe0710"]])

export default __exports__